@if (overlay) {
  <div class="loading-overlay">
    <tds-spinner size="{{ size }}" variant="{{ variant }}"></tds-spinner>
  </div>
} @else {
  <tds-spinner size="{{ size }}" variant="{{ variant }}"></tds-spinner>
}
